import { CATEGORY4CONSTANTS } from 'constants/Scope3Constants/category4.constants';
import axiosInstance from 'interceptor/axiosInstance';
import { Category4 } from 'models/Scope3/category4.model';
import { useState } from 'react';
import { generatePath } from 'react-router-dom';
import { ApiRoutes } from 'routes/routeConstants/apiRoutes';
import { deserialize, serialize } from 'serializr';
import Notification from 'shared/components/Notification';
import { NotificationTypes } from 'enums/notificationTypes';
import { generateAddressLabel } from 'views/Scope3/Category4&9/LocationModal';
import { dataUpdatedMessage } from 'constants/constants';

const Category4Service = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [category4Data, setCategory4Data] = useState<Category4>();

  const getCategory4Data = async (params: {
    locationId: string;
    year: number;
  }) => {
    try {
      setLoading(true);
      const url = generatePath(ApiRoutes.SCOPE_CATEGORY, {
        ...params,
        category: CATEGORY4CONSTANTS.CATEGORY_NAME,
      });
      const response = await axiosInstance.get(url);
      const categoryData = deserialize(Category4, response?.data);
      //Generating addressLabel for all addresses
      const modifiedCategoryData: Category4 = {
        ...categoryData,
        finishedGoods: {
          ...categoryData?.finishedGoods,
          products: categoryData?.finishedGoods?.products?.map(product => {
            return {
              ...product,
              ...(product?.address && {
                addressLabel: generateAddressLabel(product.address),
              }),
            };
          }),
        },
      };
      setCategory4Data(modifiedCategoryData);
      return modifiedCategoryData;
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const updateCategory4Data = async (
    data: Category4,
    params: {
      locationId: string;
      year: number;
    }
  ) => {
    try {
      setLoading(true);
      const url = generatePath(ApiRoutes.SCOPE_CATEGORY, {
        ...params,
        category: CATEGORY4CONSTANTS.CATEGORY_NAME,
      });
      const serializedData = serialize(Category4, data);
      const response = await axiosInstance.put(url, serializedData);
      Notification({
        message: response?.data?.message ?? dataUpdatedMessage,
        description: '',
        type: NotificationTypes.SUCCESS,
      });
      return true;
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    category4Data,
    getCategory4Data,
    updateCategory4Data,
  };
};

export default Category4Service;
